
import * as dayjs from 'dayjs';

/** Version number of the application */
export const version = '0.0.0';
/** Version number of the base application */
export const core_version = '1.0.0';
/** Build time of the application */
export const build = dayjs(1590644393000);
